import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { ToggleWrapper, SliderWrapper, Input, Slider } from 'src/domains/layouts/shared/toggle/Toggle.style';

export interface TogglePropsType {
    className?: string;
    label?: string;
    toggleActive: () => Promise<void>;
    isActive: boolean;
    isDisabled?: boolean;
    dataTest?: string;
}

export const Toggle = observer('Toggle', ({ className, label, toggleActive, isActive, isDisabled, dataTest }: TogglePropsType) => {
    return (
        <ToggleWrapper className={className} isDisabled={isDisabled} onClick={toggleActive}>
            {label === undefined ? 'Publish' : `${label}`}
            <SliderWrapper data-test={dataTest}>
                <Input
                    type='checkbox'
                    checked={isActive}
                    readOnly
                />
                <Slider />
            </SliderWrapper>
        </ToggleWrapper>
    );
});
